import React, { useEffect, useState } from "react";
import FormBuilder from "../form_components/FormBuilder";
import MultiSelect, { SelectionOption } from "../form_components/MultiSelect";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { fetchEventTypes, fetchHandles } from "../../features/Actions/ActionSlice";
import Input from "../form_components/Input";
import { useNotification } from "../../context/NotificationContext";
import SearchSelect from "components/form_components/SearchSelect";

export default function AddAction() {
  const { notify } = useNotification();
    const dispatch = useAppDispatch();
    const handles = useAppSelector(state => state.Actions.handles);

    useEffect(() => {
        dispatch(fetchHandles());
    }, [dispatch]);


    const options: SelectionOption[] = handles.map(handle => ({
        option: handle.label,
        enabled: true
    }));

    type Tool = { short: string; name: string };
        

    const onSubmit = () => {
        dispatch(fetchEventTypes());
    };

    return (
        <FormBuilder
            title='Add Action'
            post='/events/eventtypes'
            onSubmit={() => {
                onSubmit();
                notify("New action added.");
            }}
            initialValues={{
                "handles": "Start,End,Failure"
            }}
        >
            <Input width='full' label="Action Name" type='text' placeholder='CTD' extraClasses='border block rounded px-2' required={true} value='' onChange={(name, value) => { }} name='name' />
            <MultiSelect name="handles" options={options}/>
            
            <SearchSelect<Tool>
                width="full"
                label="L22 Device type"
                name="allowed_devices"       // used for formValues
                dataUrl="/data/tools.json"
                getOptionLabel={(o) => o.name} // shown in input
                getOptionValue={(o) => o.short}  // posted value
                placeholder="Select a device"
                extraClasses="border block rounded px-2"
                required
            />

        </FormBuilder>
    );
}